import styled from 'styled-components';
import * as Buttons from '../../styles/lib/buttons';

export { Buttons };
export const Icon = styled.img``;

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

export const Content = styled.div`
  padding: 40px 20px;
  width: 100%;
  max-width: 1268px;
  min-height: 670px;

  @media (max-width: 1280px) {
    max-width: 1000px;
  }

  @media (max-width: 1024px) {
    max-width: 768px;
  }
`;

export const ContentContainer = styled.div`
  margin: 40px 0px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px 64px;

  @media (max-width: 1280px) {
    max-width: 992px;
  }

  @media (max-width: 1024px) {
    max-width: 728px;
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  color: rgb(3, 59, 113);

  @media (max-width: 766px) {
    font-size: 18px;
  }
`;

export const Items = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const InfoWrapper = styled.div`
  width: 100%;
  max-width: 550px;
`;

export const Text = styled.div`
  color: #033b71;
  width: 100%;
  max-width: 150px;

  &.extended {
    width: 100%;
    max-width: 350px;
    color: #033b71;
  }

  &.bold {
    font-weight: 700;
  }

  &.vendor-code {
    width: auto;
    color: #033b71;
    padding-right: 3%;
    align-items: center;
    vertical-align: middle;
    justify-content: center;
    display: flex;
  }
`;

export const Section = styled.div`
  width: 100%;
  margin-bottom: 2rem;
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  color: #022e57;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 4px;
  margin-bottom: 16px;
`;

export const Label = styled.div`
  font-weight: 600;
  color: #033b71;
  min-width: 150px;
`;

export const Value = styled.div`
  flex: 1;
  color: #033b71;

  &.vendor {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: start;
  }
`;
